import React, { useState, useEffect,useCallback } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Tabs,
  Tab,
  FormControl,
  Select,
  MenuItem, IconButton, Tooltip
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axiosInstance from "../common/axios"; // ✅ your configured Axios instance
import { useAuth } from '../context/AuthContext';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FormInstructionBox from '../components/FormInstructionBox';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ShipperRequest = () => {
  const [currentPage, setCurrentPage] = useState("requests"); // 'requests', 'assigned', 'completed'
  const [previousPage, setPreviousPage] = useState("requests");
  const [requests, setRequests] = useState([]);
  const [assignedOrders, setAssignedOrders] = useState([]);
  const [completedShipments, setCompletedShipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  const { user } = useAuth();
  
  const [paginationModel, setPaginationModel] = useState({ 
        page: 0, 
        pageSize: 5 
    });
  const [totalRowCount, setTotalRowCount] = useState(0);
  
      const shipperrequestInstructions = [
        "Look at the zipcode if you can able to deliver to this zipcode and it is your homezone click on Approve",
        "if you are not able to ship to the zipcode click on Deny",
        "Click on the  orde to see the delivery address.",
          "Once you are done with the Pickup and started to delivery change  the status to On the Way",
          "If you are delivering the product the Customer then select delivered", 
          "When you are Picking up the product, change the status to Picked Up",
        "If you have any Questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128"
    ];

  const {
    userId,
    roles, 
    userTypes,
    partnerId
  } = user || {};
  

  // 🔹 Load data depending on current tab
  useEffect(() => {
    if (!userId) return;
    fetchData(currentPage,paginationModel.page, paginationModel.pageSize);
  }, [currentPage, userId,paginationModel.page, paginationModel.pageSize]);
  
  
  const fetchData = useCallback(async (type,page, pageSize) => {
    setLoading(true); 
    setError("");
    try {
      let url = "";
      if (type === "requests") url = `${backendUrl}/api/shipperrequest/requests/by-shipper/${userId}`;
      else if (type === "assigned") url = `${backendUrl}/api/shipperrequest/assignments/by-shipper/${userId}`;
      else if (type === "completed") url = `${backendUrl}/api/shipperrequest/assignments/by-shipper/${userId}/delivered`;

      const response = await  axiosInstance.get(url, 
        {
          params: {
                    page: page,
                    size: pageSize
                }
      }); //axiosInstance.get(url);
      const data = response.data || [];
      
           
      if (type === "requests") setRequests(data);
      if (type === "assigned") setAssignedOrders(data.content);
      if (type === "completed") setCompletedShipments(data.content);
      
       setTotalRowCount(data.totalElements);
      
    } catch (err) {
      console.error(err);
      setError("Failed to load data. Please try again.");
    } finally {
      setLoading(false);
            setOrderDetails([]);
       setSelectedOrderId(null);
    }
  }, []);

  // 🔹 Approve request
  const handleApprove = async (requestId) => {
    setLoading(true);
    setError("");
    try {
      await axiosInstance.post(`${backendUrl}/api/shipperrequest/requests/${requestId}/accept`, { userId });
      // Refresh lists
      await fetchData("requests",paginationModel.page, paginationModel.pageSize);
      await fetchData("assigned",paginationModel.page, paginationModel.pageSize);
      setCurrentPage("assigned",paginationModel.page, paginationModel.pageSize);
    } catch (err) {
      console.error(err);
      setError("Failed to approve request.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Deny request
  const handleDeny = async (requestId) => {
    setLoading(true);
    setError("");
    try {
      await axiosInstance.post(`${backendUrl}/api/shipperrequest/requests/${requestId}/deny`, { userId });
      await fetchData("requests",paginationModel.page, paginationModel.pageSize);
    } catch (err) {
      console.error(err);
      setError("Failed to deny request.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Update shipment status
  const handleStatusUpdate = async (assignmentId, newStatus) => {
    setLoading(true);
    setError("");
    try {
      const dto = {
        newStatus,
        updatedByUserId: userId,
      };
      await axiosInstance.post(`${backendUrl}/api/shipperrequest/assignments/${assignmentId}/status`, dto);
      await fetchData("assigned",paginationModel.page, paginationModel.pageSize);
      if (newStatus === "DELIVERED") {
        await fetchData("completed",paginationModel.page, paginationModel.pageSize);
        setCurrentPage("completed");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to update status.");
    } finally {
      setLoading(false);
    }
  };
    
  const fetchOrderDetails = async (orderId) => {
    setDetailsLoading(true);
    setSelectedOrderId(orderId);
    try {
      const res = await axiosInstance.get(`${backendUrl}/api/fulfillment-orders/by-orders`, {
    params: {
        orderId: orderId // Axios will correctly convert this to ?orderId=...
    }
    }); // adjust your endpoint
      setOrderDetails(res.data); 
        
    } catch (err) {
      console.error("Error fetching order details:", err);
      setOrderDetails([]);
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setPaginationModel((prev) => ({ ...prev, pageSize: 5, page: 0 }));
    setCurrentPage(newValue);
      setOrderDetails([]);
       setSelectedOrderId(null);
  };

  // 🔹 Columns
  const requestColumns = [
    { field: "orderId", headerName: "Order ID", width: 120 },
    { field: "customerZipcode", headerName: "Customer Zipcode", flex: 1 },
    { field: "requestStatus", headerName: "Status", flex: 1 },
       { field: "slotStartTimeString", headerName: "Delivery Start Time", width: 150 },
      { field: "slotEndTimeString", headerName: "Delivery End Time", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleApprove(params.row.requestId)}
            disabled={loading}
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDeny(params.row.requestId)}
            disabled={loading}
          >
            Deny
          </Button>
        </Box>
      ),
    },
  ];

  const assignedColumns = [
    { field: "orderId", headerName: "Order ID", width: 120 },
    { field: "customerName", headerName: "Customer", flex: 1 },
    { field: "address", headerName: "Address", flex: 1,
     renderCell: (params) => (
            <Box 
                sx={{
                    // IMPORTANT: Allow text to wrap
                    whiteSpace: 'normal', 
                    // Set height to 'auto' to ensure the box adjusts to wrapped content
                    lineHeight: 'normal', 
                    // Add padding for better visual spacing
                    py: 1 
                }}
            >
                {/* params.value is the address string */}
                {params.value}
            </Box>
        ),
    },
       
    { field: "requestStatus", headerName: "Status", width: 150 },
    {
      field: "updateStatus",
      headerName: "Update Status",
      width: 250,
      renderCell: (params) => (
        <FormControl fullWidth size="small">
          <Select
            value={params.row.currentStatus}
            onChange={(e) =>
              handleStatusUpdate(params.row.assignmentId, e.target.value)
            }
          >
            <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
            <MenuItem value="PICKED_UP">Picked Up</MenuItem>
            <MenuItem value="ON_THE_WAY">On the Way</MenuItem>
            <MenuItem value="DELIVERED">Delivered</MenuItem>
          </Select>
        </FormControl>
      ),
    },
    {
      field: "map",
      headerName: "Map",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        const { latitude, longitude, address } = params.row;

        // ✅ Build the map URL dynamically
        const mapUrl =
          latitude && longitude
            ? `https://www.google.com/maps?q=${latitude},${longitude}`
            : address
            ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
            : null;

        if (!mapUrl) return null; // no address or coords available

        return (
          <Tooltip title="View on Google Maps">
            <IconButton
              color="primary"
              onClick={() => window.open(mapUrl, "_blank")}
            >
              <LocationOnIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const completedColumns = [
    { field: "orderId", headerName: "Order ID", width: 120 },
    { field: "customerName", headerName: "Customer", flex: 1 },
    { field: "address", headerName: "Address", flex: 1, 
     
     renderCell: (params) => (
            <Box 
                sx={{
                    // IMPORTANT: Allow text to wrap
                    whiteSpace: 'normal', 
                    // Set height to 'auto' to ensure the box adjusts to wrapped content
                    lineHeight: 'normal', 
                    // Add padding for better visual spacing
                    py: 1 
                }}
            >
                {/* params.value is the address string */}
                {params.value}
            </Box>
        ),
    },
    { field: "completionDate", headerName: "Completion Date", width: 150 },
  ];
    
  const detailColumns = [
      
    { field: "customerOrderId", headerName: "Order ID", width: 120 },
    { field: "fulfillmentStatusName", headerName: "Status", width: 150 },
      { field: "slotStartTimeString", headerName: "Delivery Start Time", width: 180 },
      { field: "slotEndTimeString", headerName: "Delivery End Time", width: 180 },
    { field: "warehouseAddress", headerName: "Address", flex: 1, 
     
     renderCell: (params) => (
            <Box 
                sx={{
                    // IMPORTANT: Allow text to wrap
                    whiteSpace: 'normal', 
                    // Set height to 'auto' to ensure the box adjusts to wrapped content
                    lineHeight: 'normal', 
                    // Add padding for better visual spacing
                    py: 1 
                }}
            >
                {/* params.value is the address string */}
                {params.value}
            </Box>
        ),
    },
    {
      field: "map",
      headerName: "Map",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        const { latitude, longitude, warehouseAddress } = params.row;
        // ✅ Build the map URL dynamically
        const mapUrl =
          latitude && longitude
            ? `https://www.google.com/maps?q=${latitude},${longitude}`
            : warehouseAddress
            ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(warehouseAddress)}`
            : null;

        if (!mapUrl) return null; // no address or coords available

        return (
          <Tooltip title="View on Google Maps">
            <IconButton
              color="primary"
              onClick={() => window.open(mapUrl, "_blank")}
            >
              <LocationOnIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];


  const renderContent = () => {
    if (loading)
      return (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      );

    const gridProps = {
      autoHeight: true,
      pageSizeOptions: [5, 10, 20],
    };

    switch (currentPage) {
      case "requests":
        return (
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Pending Shipping Requests ({requests.length})
            </Typography>
            <DataGrid
              rows={requests}
              getRowId={(row) => row.requestId || row.id}
              columns={requestColumns}
              {...gridProps}
            />
          </Box>
        );
      case "assigned":
        return (
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Current Assignments ({assignedOrders.length})
            </Typography>
            
   <DataGrid
    pagination
    paginationMode="server"
    rows={assignedOrders}
    columns={assignedColumns}
    rowCount={totalRowCount}
    page={paginationModel.page}
    pageSize={paginationModel.pageSize}
    onPageChange={(newPage) => {
      setPaginationModel((prev) => ({ ...prev, page: newPage }));
    }}
    onPageSizeChange={(newPageSize) => {
      console.log("Page size changed:", newPageSize);
      setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize, page: 0 }));
    }}
    rowsPerPageOptions={[5, 10, 20]} // ✅ correct prop for v5
    loading={loading}
    getRowId={(row) => row.assignmentId}
    disableColumnFilter
    disableColumnSorting
    onRowClick={(params) => fetchOrderDetails(params.row.orderId)}
      {...gridProps}
  />
   
          </Box>
        );
      case "completed":
        return (
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Completed Shipments ({completedShipments.length})
            </Typography>
            
             <DataGrid
    pagination
    paginationMode="server"
    rows={completedShipments}
    columns={completedColumns}
    rowCount={totalRowCount}
    page={paginationModel.page}
    pageSize={paginationModel.pageSize}
    onPageChange={(newPage) => {
      setPaginationModel((prev) => ({ ...prev, page: newPage }));
    }}
    onPageSizeChange={(newPageSize) => {
      console.log("Page size changed:", newPageSize);
      setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize, page: 0 }));
    }}
    rowsPerPageOptions={[5, 10, 20]} // ✅ correct prop for v5
    loading={loading}
     getRowId={(row) => row.assignmentId || row.id}
    disableColumnFilter
    disableColumnSorting
    onRowClick={(params) => fetchOrderDetails(params.row.orderId)}
      {...gridProps}
  />

          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 4,
        minHeight: "100vh",
        bgcolor: "#f3f4f6",
      }}
    >
      <Paper
        elevation={4}
        sx={{ width: "100%", maxWidth: "960px", p: 4, borderRadius: "12px" }}
      >
        <Typography
          variant="h4" 
          component="h1"
          gutterBottom
          sx={{ textAlign: "center", fontWeight: "bold" }}
        >
          Shipper Request
        </Typography>
        
            <FormInstructionBox 
                instructions={shipperrequestInstructions} 
                title="Shipper Request Guidelines" 
            />

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 4 }}>
          <Tabs value={currentPage} onChange={handleTabChange} centered>
            <Tab label="Pending Requests" value="requests" />
            <Tab label="Current Assignments" value="assigned" />
            <Tab label="Completed Shipments" value="completed" />
          </Tabs>
             {selectedOrderId && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Order Details — ID #{selectedOrderId}
          </Typography>
          {detailsLoading ? (
            <CircularProgress />
          ) : orderDetails.length > 0 ? (
            <DataGrid
              rows={orderDetails}
             getRowId={(row) => row.fulfillmentOrderId} 
              columns={detailColumns}
              autoHeight
            />
          ) : (
            <Typography color="text.secondary">
              No details available for this order.
            </Typography>
          )}
        </Paper>
      )}
        </Box>

        {error && (
          <Typography color="error" sx={{ textAlign: "center", mb: 2 }}>
            {error}
          </Typography>
        )}

        {renderContent()}
      </Paper>
    </Box>
  );
};

export default ShipperRequest;
